import { ROUTES } from "../constants";
import { reportAnalyticsTypes } from "./dashboard";
import {
  ReportAnalysisTypeWithMetadata,
  CreateOption,
} from "../components/AllReportsAndAnalysis/types";

// Create options for the dropdown
export const createOptions: CreateOption[] = [
  {
    id: "create-mfr",
    label: "Create MFR",
    description: "Monthly Financial Report",
    route: ROUTES.MFR_CREATE,
  },
  {
    id: "create-netppm",
    label: "Create NetPPM",
    description: "Net PPM Insights Analysis",
    route: ROUTES.NETPPM_CREATE,
  },
  {
    id: "create-rvm",
    label: "Create RVM",
    description: "Rate-Volume-Mix Analysis",
    route: ROUTES.RVM_CREATE,
  },
];

// Sample data with metadata - in a real app, this would come from an API
export const reportsWithMetadata: ReportAnalysisTypeWithMetadata[] = [
  {
    workflowName: "NA Retail Executive P&L Analysis (vs OP2)",
    workflowId: "MFR",
    workflowShortName: "MFR",
    workflowDescription:
      "Executive P&L overview for North America retail operations",
    workflowActions: reportAnalyticsTypes[0].workflowActions,
    lastRun: "2025-08-15T07:30:00.000Z",
    status: "completed",
    createdAt: "2025-01-15T10:00:00.000Z",
    updatedAt: "2025-08-15T07:30:00.000Z",
    runCount: 12,
  },
  {
    workflowName: "Global Multi-Channel Rate-Volume-Mix Analysis",
    workflowId: "RVM",
    workflowShortName: "RVM",
    workflowDescription:
      "Comprehensive RVM analysis across all regions and channels",
    workflowActions: reportAnalyticsTypes[2].workflowActions,
    lastRun: "2025-08-25T09:45:00.000Z",
    status: "completed",
    createdAt: "2025-02-01T14:30:00.000Z",
    updatedAt: "2025-08-25T09:45:00.000Z",
    runCount: 8,
  },
  {
    workflowName: "NA BEATS NetPPM Variance Analysis",
    workflowId: "NetPPM",
    workflowShortName: "NetPPM",
    workflowDescription:
      "NetPPM variance tracking for North America BEATS operations",
    workflowActions: reportAnalyticsTypes[1].workflowActions,
    lastRun: "2025-08-20T04:20:00.000Z",
    status: "completed",
    createdAt: "2025-03-10T11:15:00.000Z",
    updatedAt: "2025-08-20T04:20:00.000Z",
    runCount: 15,
  },
];
